module.exports = __webpack_public_path__ + "static/media/marcus-smart-banner-min.e693778a.png";